import { AccessLog, SearchResponse } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const accessLogApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    getAccessLogs: builder.query<SearchResponse<AccessLog>, { skip: number; take: number }>({
      query: params => ({
        url: `AccessLog/GetByUserId`,
        params,
      }),
      providesTags: [{ type: "AccessLog" as const, id: "LIST" }],
    }),
  }),
})

export const { useGetAccessLogsQuery } = accessLogApi
